import { Timestamp } from "firebase/firestore";
import { Navbar } from "../../../components/Navbar"
import { Project } from "../../../data/Project";
import { useProfile } from "../../../providers/ProfileProvider";
import { useProject } from "../../../providers/ProjectProvider";

import moment from 'moment'
import { ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export type ProjectListPageProps = {
    
}

/*
 * The project labeler page.
 */
export const ProjectListPage: React.FC<ProjectListPageProps> = ({}) => {
    const { projects } = useProject();
    

    const formatFromNow = (date: Timestamp) => {
        return moment(date.toDate()).fromNow();
    }

    // Sort projects by lastUpdatedAt in descending order
    const sortedProjects = [...projects].sort((a, b) => b.lastUpdatedAt.toMillis() - a.lastUpdatedAt.toMillis());

    return (
        <div className="min-h-screen bg-gray-100 p-4">
            <h1 className="text-3xl font-bold mb-4">Your projects</h1>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white shadow-lg rounded-lg">
                    <thead>
                        <tr>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Project Name</th>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Identifier</th>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Description</th>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Last Updated</th>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedProjects.map((project: Project) => (
                            <tr key={project.id} className="hover:bg-gray-100 transition-colors duration-300">
                                <td className="px-6 py-4 border-b border-gray-300">{project.name}</td>
                                <td className="px-6 py-4 border-b border-gray-300 font-mono">{project.identifier}</td>
                                <td className="px-6 py-4 border-b border-gray-300">{project.description}</td>
                                <td className="px-6 py-4 border-b border-gray-300">{formatFromNow(project.lastUpdatedAt)}</td>
                                <td className="px-6 py-4 border-b border-gray-300">
                                    <Link to={`/projects/${project.id}`}>
                                        <button className="flex items-center space-x-2 text-indigo-500 hover:text-indigo-700">
                                            <ArrowRight size={24} />
                                            <span>Open</span>
                                        </button>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}